import { useAuth } from "oidc-react";
import { PropsWithChildren } from "react";
import { useLicense } from "../../hooks/useLicense";
import LicenseBackground from "./LicenseBackground";

interface ILicenseWrapperProps extends PropsWithChildren {
}

const LicenseWrapper = (props:ILicenseWrapperProps) => {

    const auth = useAuth();

    const { isBeforeTarget } = useLicense();


    if(auth.isLoading){
        return (
            <p>Loading ...</p>
        );
    }
        
    if(isBeforeTarget){
        return (
            <>
                {props.children}
            </>
        )
        
    }

    return (
        <div>
            <div style={{ position: 'relative' }}>
                <LicenseBackground />
                {/* No License */}
            </div>
        </div>
    )
};

export default LicenseWrapper;
